import { useCallback, useEffect, useState } from 'react';

import type { PublicTemporaryMessage } from '@api-client/temporary-messages';
import { useGlobalEvent } from '@luna/events';

import { useTemporaryMessagesState } from './useTemporaryMessagesState';
import { useTemporaryMessagesWithPolling } from './messages-header/useTemporaryMessagesWithPolling';
import { filterTemporaryMessagesToDisplay } from './TemporaryMessageToDisplayService';
import type { ScreenToPathsMap } from './TemporaryMessagesTypes';

interface UseTemporaryMessageReturn {
    displayedMessage: PublicTemporaryMessage | undefined;
}

export const useTemporaryMessage = (
    screenToPathsMap: ScreenToPathsMap,
): UseTemporaryMessageReturn => {
    const temporaryMessages = useTemporaryMessagesWithPolling();
    const [messagesToDisplay, setMessagesToDisplay] = useState<PublicTemporaryMessage[]>([]);
    const { closedMessagesIds } = useTemporaryMessagesState();

    const updateMessagesToDisplay = useCallback(() => {
        setMessagesToDisplay(
            filterTemporaryMessagesToDisplay(
                temporaryMessages,
                closedMessagesIds,
                screenToPathsMap,
            ),
        );
    }, [temporaryMessages, closedMessagesIds]);

    useGlobalEvent('route:change', () => {
        updateMessagesToDisplay();
    });

    useEffect(() => {
        updateMessagesToDisplay();
    }, [updateMessagesToDisplay]);

    return {
        displayedMessage: messagesToDisplay[0],
    };
};
